<template>
    <b-container fluid>
        <b-row>
            <b-col xl="12" lg="12" sm="12">
                <iq-card>
                    <template v-slot:headerTitle>
                        <h4 v-if="mat_id === 0" class="card-title">{{ $t('sales_distribution_admin.sales_target') + ' ' + $t('globalTrans.entry') }}</h4>
                        <h4 v-else-if="view === true" class="card-title">{{ $t('sales_distribution_admin.sales_target') + ' ' + $t('production_store.details') }}</h4>
                        <h4 v-else class="card-title">{{ $t('sales_distribution_admin.sales_target') + ' ' + $t('globalTrans.modify') }}</h4>
                    </template>
                    <template v-slot:headerAction>
                        <router-link to="sales-target" :class="'btn btn-primary text-light'"><i class="ri-file-text-line"></i>{{  $t('sales_distribution_admin.sales_target') + ' ' + $t('globalTrans.list') }}</router-link>
                    </template>
                    <template v-slot:body>
                           <b-overlay :show="loading">
                            <b-row v-if="view === false">
                                <b-col class="col-12">
                                    <ValidationObserver ref="form1"  v-slot="{ handleSubmit, reset }">
                                        <b-form  @submit.prevent="handleSubmit(addItem)" @reset.prevent="reset" >
                                            <b-row>
                                                <b-col lg="4" sm="12" md="4">
                                                    <ValidationProvider name="Fiscal Year" vid="fiscal_year_id" rules="required|min_value:1">
                                                    <b-form-group
                                                        class="row"
                                                        label-cols-sm="12"
                                                        label-for="fiscal_year_id"
                                                        slot-scope="{ valid, errors }"
                                                        >
                                                        <template v-slot:label>
                                                        {{$t('sales_distribution_admin.year')}} <span class="text-danger">*</span>
                                                        </template>
                                                        <b-form-select
                                                        plain
                                                        v-model="dataArray.fiscal_year_id"
                                                        id="fiscal_year_id"
                                                        :options="fiscalYearList"
                                                        :state="errors[0] ? false : (valid ? true : null)"
                                                        >
                                                        <template v-slot:first>
                                                            <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                        </template>
                                                        </b-form-select>
                                                        <div class="invalid-feedback">
                                                            {{ errors[0] }}
                                                        </div>
                                                    </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                                <b-col lg="4" sm="12" md="4">
                                                    <ValidationProvider name="Month" vid="month" rules="required|min_value:1">
                                                    <b-form-group
                                                        class="row"
                                                        label-cols-sm="12"
                                                        label-for="month"
                                                        slot-scope="{ valid, errors }"
                                                        >
                                                        <template v-slot:label>
                                                        {{$t('sales_distribution_admin.month')}} <span class="text-danger">*</span>
                                                        </template>
                                                        <b-form-select
                                                        plain
                                                        v-model="dataArray.month"
                                                        id="month"
                                                        :options="monthList"
                                                        :state="errors[0] ? false : (valid ? true : null)"
                                                        >
                                                        <template v-slot:first>
                                                            <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                        </template>
                                                        </b-form-select>
                                                        <div class="invalid-feedback">
                                                            {{ errors[0] }}
                                                        </div>
                                                    </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                            </b-row>
                                            <b-row>
                                                <b-col lg="4" sm="12" md="4">
                                                    <ValidationProvider name="Sales Center" vid="sales_center_id" rules="required|min_value:1">
                                                    <b-form-group
                                                        class="row"
                                                        label-cols-sm="12"
                                                        label-for="sales_center_id"
                                                        slot-scope="{ valid, errors }"
                                                        >
                                                        <template v-slot:label>
                                                        {{$t('sales_distribution_admin.sales_center')}} <span class="text-danger">*</span>
                                                        </template>
                                                        <b-form-select
                                                        plain
                                                        v-model="detailsFormData.sales_center_id"
                                                        id="sales_center_id"
                                                        :options="salesCenterList"
                                                        :state="errors[0] ? false : (valid ? true : null)"
                                                        >
                                                        <template v-slot:first>
                                                            <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                        </template>
                                                        </b-form-select>
                                                        <div class="invalid-feedback">
                                                            {{ errors[0] }}
                                                        </div>
                                                    </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                                <b-col lg="4" sm="12" md="4">
                                                    <ValidationProvider name="Product Category" vid="category_id" rules="required|min_value:1">
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="12"
                                                            label-for="category_id "
                                                            slot-scope="{ valid, errors }">
                                                            <template v-slot:label>
                                                                {{$t('production_store.pro_category')}} <span class="text-danger">*</span>
                                                            </template>
                                                            <b-form-select
                                                                plain
                                                                v-model="detailsFormData.category_id"
                                                                id="category_id"
                                                                :options="categoryList"
                                                                :state="errors[0] ? false : (valid ? true : null)">
                                                                <template v-slot:first>
                                                                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                                </template>
                                                            </b-form-select>
                                                            <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                                <b-col lg="4" sm="12" md="4">
                                                    <ValidationProvider name="Target Amount" vid="target_amount" rules="required|min_value:1">
                                                    <b-form-group
                                                        class="row"
                                                        label-cols-sm="12"
                                                        label-for="target_amount"
                                                        slot-scope="{ valid, errors }"
                                                        >
                                                        <template v-slot:label>
                                                            {{ $t('sales_distribution_admin.target_amount') }} <span class="text-danger">*</span>
                                                        </template>
                                                        <b-form-input
                                                            type="number"
                                                            id="target_amount"
                                                            v-model="detailsFormData.target_amount"
                                                            :state="errors[0] ? false : (valid ? true : null)"
                                                        ></b-form-input>
                                                        <div class="invalid-feedback">
                                                            {{ errors[0] }}
                                                        </div>
                                                    </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                            </b-row>
                                            <b-row>
                                                <b-col lg="4" sm="12">
                                                    <b-form-group
                                                        class="row"
                                                        label-cols-sm="12"
                                                        label-for="remark_en"
                                                    >
                                                        <template v-slot:label>
                                                        {{ $t('production_store.remark_en')}}
                                                        </template>
                                                        <b-form-textarea
                                                        row="1"
                                                        id="remark_en"
                                                        v-model="detailsFormData.remark"
                                                        ></b-form-textarea>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col lg="4" sm="12">
                                                    <b-form-group
                                                        class="row"
                                                        label-cols-sm="12"
                                                        label-for="remark_bn"
                                                    >
                                                        <template v-slot:label>
                                                        {{ $t('production_store.remark_bn')}}
                                                        </template>
                                                        <b-form-textarea
                                                        row="1"
                                                        id="office_name"
                                                        v-model="detailsFormData.remark_bn"
                                                        ></b-form-textarea>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col lg="4" sm="12" class="align-self-center text-left">
                                                    <b-button type="submit" variant="primary"><i class="ri-add-circle-line"></i>{{ $t('globalTrans.add') }}</b-button>
                                                </b-col>
                                            </b-row>
                                        </b-form>
                                    </ValidationObserver>
                                    <ValidationObserver ref="form" v-slot="{ handleSubmit, reset }">
                                        <b-form  @submit.prevent="handleSubmit(saveData)" @reset.prevent="reset" >
                                            <hr>
                                             <b-row class="mt-4">
                                                <b-col>
                                                    <b-overlay :show="unitLoad">
                                                    <table class="table table-bordered">
                                                        <tr class="bg-light">
                                                            <th width="100px">{{ $t('globalTrans.sl_no') }}</th>
                                                            <th>{{ $t('sales_distribution_admin.sales_center') }}</th>
                                                            <th>{{ $t('production_store.pro_category') }}</th>
                                                            <th>{{ $t('sales_distribution_admin.remark_en') }}</th>
                                                            <th>{{ $t('sales_distribution_admin.remark_bn') }}</th>
                                                            <th>{{ $t('sales_distribution_admin.target_amount') }}</th>
                                                            <th>{{ $t('globalTrans.action') }}</th>
                                                        </tr>
                                                        <tr v-for="(item, index) in dataArray.details" :key="index">
                                                            <td>{{ $n(index + 1) }}</td>
                                                            <td>{{ salesCenterNameById(item.sales_center_id) }}</td>
                                                            <td>{{ getCategoryName(item.category_id) }}</td>
                                                            <td>
                                                                <ValidationProvider name="remark_en (En)">
                                                                    <b-form-group
                                                                        slot-scope="{ valid, errors }"
                                                                    >
                                                                        <b-form-input
                                                                        v-model="item.remark"
                                                                        :state="errors[0] ? false : (valid ? true : null)"
                                                                        ></b-form-input>
                                                                        <div class="invalid-feedback">
                                                                        {{ errors[0] }}
                                                                        </div>
                                                                    </b-form-group>
                                                                </ValidationProvider>
                                                            </td>
                                                            <td>
                                                                <ValidationProvider name="remark_bn (Bn)">
                                                                    <b-form-group
                                                                        slot-scope="{ valid, errors }"
                                                                    >
                                                                        <b-form-input
                                                                        v-model="item.remark_bn"
                                                                        :state="errors[0] ? false : (valid ? true : null)"
                                                                        ></b-form-input>
                                                                        <div class="invalid-feedback">
                                                                        {{ errors[0] }}
                                                                        </div>
                                                                    </b-form-group>
                                                                </ValidationProvider>
                                                            </td>
                                                            <td>
                                                                <ValidationProvider name="Target Amount" rules="required">
                                                                    <b-form-group
                                                                        slot-scope="{ valid, errors }"
                                                                    >
                                                                        <b-form-input
                                                                        type="number"
                                                                        v-model="item.target_amount"
                                                                        :state="errors[0] ? false : (valid ? true : null)"
                                                                        ></b-form-input>
                                                                        <div class="invalid-feedback">
                                                                        {{ errors[0] }}
                                                                        </div>
                                                                    </b-form-group>
                                                                </ValidationProvider>
                                                            </td>
                                                            <td>
                                                                <button @click="deleteItem(index)" class="btn btn-danger btn-xs"><i class="fa fa-trash"></i></button>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td colspan="5" class="text-right">{{ $t('sales_distribution_admin.grand_total') }}</td>
                                                            <td colspan="1" class="text-center">{{ getTotal(dataArray) }}</td>
                                                            <td></td>
                                                        </tr>
                                                    </table>
                                                    </b-overlay>
                                                </b-col>
                                            </b-row>
                                            <b-row>
                                                <b-col lg="4" sm="12">
                                                    <ValidationProvider name="Target Date" vid='target_date' rules="required">
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="12"
                                                            label-for="target_date"
                                                            slot-scope="{ valid, errors }"
                                                        >
                                                            <template v-slot:label>
                                                            {{ $t('production_store.target_date')}} <span class="text-danger">*</span>
                                                            </template>
                                                            <b-form-input
                                                            placeholder="Select Date"
                                                            id="target_date"
                                                            v-model="dataArray.target_date"
                                                            :state="errors[0] ? false : (valid ? true : null)"
                                                            ></b-form-input>
                                                            <div class="invalid-feedback">
                                                            {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                                <b-col lg="4" sm="12">
                                                    <ValidationProvider name="Comment (En)" vid='comment'>
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="12"
                                                            label-for="comment"
                                                            slot-scope="{ valid, errors }"
                                                        >
                                                            <template v-slot:label>
                                                            {{ $t('production_store.comment_en')}}
                                                            </template>
                                                            <b-form-input
                                                            id="comment"
                                                            v-model="dataArray.comment_en"
                                                            :state="errors[0] ? false : (valid ? true : null)"
                                                            ></b-form-input>
                                                            <div class="invalid-feedback">
                                                            {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                                <b-col lg="4" sm="12">
                                                    <ValidationProvider name="Comment (Bn)" vid='comment_bn'>
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="12"
                                                            label-for="comment_bn"
                                                            slot-scope="{ valid, errors }"
                                                        >
                                                            <template v-slot:label>
                                                            {{ $t('production_store.comment_bn')}}
                                                            </template>
                                                            <b-form-input
                                                            id="comment_bn"
                                                            v-model="dataArray.comment_bn"
                                                            :state="errors[0] ? false : (valid ? true : null)"
                                                            ></b-form-input>
                                                            <div class="invalid-feedback">
                                                            {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                            </b-row>
                                            <div class="row">
                                                <div class="col text-right">
                                                    <b-button type="submit" variant="primary" class="mr-2">{{ saveBtnName }}</b-button>
                                                    &nbsp;
                                                    <b-button @click="cancel()" variant="danger" class="mr-1">{{ $t('globalTrans.cancel') }}</b-button>
                                                </div>
                                            </div>
                                        </b-form>
                                    </ValidationObserver>
                                </b-col>
                            </b-row>
                           </b-overlay>
                            <b-row v-if="view === true && loaded === true">
                                <b-col lg="3" class="ml-4">
                                    <span class="text-dark">
                                        {{$t('sales_distribution_admin.year')}} : {{ yearNameById(dataArray.fiscal_year_id) }}
                                    </span>
                                </b-col>
                                <b-col lg="4">
                                    <span class="text-dark">
                                        {{$t('sales_distribution_admin.month')}} : {{ monthNameById(dataArray.month) }}
                                    </span>
                                </b-col>
                                <b-col lg="4">
                                    <span class="text-dark">
                                        {{ $t('production_store.target_date')}} : {{ dataArray.target_date | dateFormat }}
                                    </span>
                                </b-col>
                                <div class="mt-4 col-lg-12 col-sm-12 col-md-12">
                                    <b-col>
                                        <b-overlay>
                                            <table class="table table-bordered">
                                                <tr class="bg-light">
                                                    <th width="100px">{{ $t('globalTrans.sl_no') }}</th>
                                                    <th>{{ $t('sales_distribution_admin.sales_center') }}</th>
                                                    <th>{{ $t('production_store.pro_category') }}</th>
                                                    <th colspan="2">{{ $t('sales_distribution_admin.remark') }}</th>
                                                    <th>{{ $t('sales_distribution_admin.target_amount') }}</th>
                                                    <!-- <th>{{ $t('sales_distribution_admin.remark_bn') }}</th> -->
                                                </tr>
                                                <tr v-for="(item, index) in dataArray.details" :key="index">
                                                    <td>{{ $n(index + 1) }}</td>
                                                    <td>{{ salesCenterNameById(item.sales_center_id) }}</td>
                                                    <td>{{ item.category_id ? getCategoryName(item.category_id) : '' }}</td>
                                                    <td colspan="2">{{ ($i18n.locate === 'bn') ? item.remark_bn : item.remark }}</td>
                                                    <td>{{ $n(item.approve_amount ? item.approve_amount : item.target_amount)}}</td>
                                                    <!-- <td>{{ item.remark_bn }}</td> -->
                                                </tr>
                                                <tr>
                                                    <td colspan="5" class="text-right">{{ $t('sales_distribution_admin.grand_total') }}:</td>
                                                    <td colspan="1" class="text-left">{{ $n(getTotal(dataArray)) }}</td>
                                                </tr>
                                            </table>
                                        </b-overlay>
                                    </b-col>
                                </div>
                            </b-row>
                    </template>
                </iq-card>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
import { mapGetters } from 'vuex'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import RestApi, { productionServiceBaseUrl } from '@/config/api_config'
import { salesTargetById, salesTargetStoreApi, salesTargetUpdateApi } from '../../api/routes'
import flatpickr from 'flatpickr'

export default {
    props: ['id'],
    components: {
        ValidationObserver,
        ValidationProvider
    },
    data () {
        return {
            saveBtnName: this.mat_id ? this.$t('globalTrans.update') : this.$t('globalTrans.save'),
            detailsFormData: {
                sales_center_id: 0,
                category_id: 0,
                target_amount: '',
                remark: '',
                remark_bn: ''
            },
            dataArray: {
                fiscal_year_id: 0,
                month: 0,
                target_date: '',
                total_amount: 0,
                comment_en: '',
                comment_bn: '',
                grand_total: 0,
                details: []
            },
            mat_id: 0,
            totalPrice: 0,
            sl: 0,
            view: false,
            loaded: false,
            unitLoad: false,
            loading: false
        }
    },
    computed: {
        categoryList: function () {
            return this.productCommonObj.productCategoryList.filter(item => item.status === 1)
        },
        salesCenterList: function () {
            return this.$store.state.commonObj.officeList.filter(center => center.office_type_id === 2)
        },
        fiscalYearList: function () {
            return this.$store.state.commonObj.fiscalYearList.filter(year => year.status === 0)
        },
        monthList: function () {
          const montObj = this.productCommonObj.monthList
          return montObj.map((obj, key) => {
            if (this.$i18n.locale === 'bn') {
              return { value: obj.value, text: obj.text_bn }
            } else {
              return { value: obj.value, text: obj.text_en }
            }
          })
        },
        currentLocale: function () {
            return this.$i18n.locale
        },
        ...mapGetters({
            productCommonObj: 'ProductionService/commonObj'
        })
    },
    mounted () {
        flatpickr('#target_date', {})
    },
    created () {
        if (this.$route.query.view) {
            this.view = true
            this.addForward = false
        }
        if (this.$route.query.id) {
            this.mat_id = this.$route.query.id
            this.getTargetInfoData(this.$route.query.id)
            this.addForward = false
        }
    },
    methods: {
        getCategoryName (Id) {
            const Obj = this.productCommonObj.productCategoryList.find(el => el.value === parseInt(Id))
            if (typeof Obj !== 'undefined') {
                return this.$i18n.locale === 'en' ? Obj.text_en : Obj.text_bn
            }
            return ''
        },
        getTotal (data) {
            let total = 0
            if (data.details.length > 0) {
                data.details.forEach((result, index) => {
                    if (this.$route.query.id) {
                        if (result.approve_amount !== null) {
                            total = total + parseInt(result.approve_amount)
                        } else {
                            total = total + parseInt(result.target_amount)
                        }
                    } else {
                        if (result.approve_amount !== undefined) {
                            total = total + parseInt(result.approve_amount)
                        } else {
                            total = total + parseInt(result.target_amount)
                        }
                    }
                })
            } else {
                total = 0
            }
            this.dataArray.total_amount = total
            return total
        },
        deleteItem (index) {
            this.dataArray.details.splice(index, 1)
        },
        cancel () {
            this.$router.push({ path: '/production-service/sales-distribution-admin/sales-target' })
        },
        addItem () {
            if (this.detailsFormData.sales_center_id !== 0) {
                const existsTarget = this.dataArray.details.some(data => data.sales_center_id === this.detailsFormData.sales_center_id && data.category_id === this.detailsFormData.category_id)
                if (existsTarget) {
                    this.dataArray.details.forEach((result, index) => {
                        if (result.sales_center_id === this.detailsFormData.sales_center_id) {
                            const totalVal = parseInt(result.target_amount) + parseInt(this.detailsFormData.target_amount)
                            this.dataArray.details[index].target_amount = totalVal
                            this.dataArray.details[index].remark = this.detailsFormData.remark
                            this.dataArray.details[index].remark_bn = this.detailsFormData.remark_bn
                            this.detailsFormData = {
                                sales_center_id: 0,
                                category_id: 0,
                                target_amount: '',
                                remark: '',
                                remark_bn: ''
                            }
                        }
                    })
                } else {
                    this.dataArray.details.push(this.detailsFormData)
                    this.detailsFormData = {
                        sales_center_id: 0,
                        category_id: 0,
                        target_amount: '',
                        remark: '',
                        remark_bn: ''
                    }
                }
                /** This will reset validation error after adding */
                this.$nextTick(() => {
                    this.$refs.form1.reset()
                })
            }
        },
        async saveData () {
            this.$store.dispatch('mutateCommonProperties', { loading: true })
            let result = null
            const loadingState = { loading: false, listReload: false }
            this.loading = true
            if (this.mat_id) {
                result = await RestApi.putData(productionServiceBaseUrl, `${salesTargetUpdateApi}/${this.mat_id}`, this.dataArray)
            } else {
                result = await RestApi.postData(productionServiceBaseUrl, salesTargetStoreApi, this.dataArray)
            }
            loadingState.listReload = true
            this.$store.dispatch('mutateCommonProperties', loadingState)
            this.loading = false

            if (result.success) {
                this.$store.commit('ProductionService/mutateCommonObj', { hasDropdownLoaded: false })
                this.$toast.success({
                    title: this.$t('globalTrans.success'),
                    message: this.id ? this.$t('globalTrans.update_msg') : this.$t('globalTrans.save_msg'),
                    color: '#D6E09B'
                })
                this.$router.push({ path: '/production-service/sales-distribution-admin/sales-target' })
            } else {
                this.$refs.form.setErrors(result.errors)
            }
        },
        salesCenterNameById (id) {
            const category = this.salesCenterList.find(center => center.value === id)
            if (this.$i18n.locale === 'bn') {
                return category.text_bn
            } else {
               return category.text_en
            }
        },
        yearNameById (id) {
            const product = this.fiscalYearList.find(product => product.value === id)
            if (this.$i18n.locale === 'bn') {
                return product.text
            } else {
               return product.text
            }
        },
        monthNameById (monthId) {
            const id = parseInt(monthId)
            const unit = this.monthList.find(month => month.value === id)
            return unit.text
        },
        async getTargetInfoData (id) {
          const result = await RestApi.getData(productionServiceBaseUrl, salesTargetById + '/' + id)
          if (result.success) {
            this.loaded = true
            this.target_id = result.data.target_id
            this.dataArray.details = result.data.sales_target_details
            this.dataArray.target_date = result.data.target_date
            this.dataArray.comment_en = result.data.comment_en
            this.dataArray.comment_bn = result.data.comment_bn
            this.dataArray.fiscal_year_id = result.data.fiscal_year_id
            this.dataArray.month = result.data.month
          }
        }
    }
}
</script>
